import { RestService } from "./RestService";

export class ScheduledContestService extends RestService {
    constructor() {
        super("/api/v1/scheduled_contests");
    }
}
